import { Box, BoxProps, ColorOptions } from '@jfs/ui-new'
import { useCallback, useEffect, useState } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../../components/Container'
import { NewTable } from '../../../components/NewTable'
import { useLazyApiData, useStores } from '../../../data/store'
import { dateFormatter, DateFormatTypes, MessageTypes } from '../../../utils'

import { CheckerHeader } from '../OnboardEntity/comps/CheckerHeader'
import { FiltersModal } from '../OnboardEntity/comps/FiltersModal'

const MyOnboardedEntityQueue = ({ route: { name }, navigation }: any) => {
  const { fetchMyQueueList, pagination, selectedDateInfo, setMessage } = useStores((store) => ({
    fetchMyQueueList: store.entityOnboarding.fetchMyQueueList,
    pagination: store.pagination,
    selectedDateInfo: store.selectedDateInfo,
    setMessage: store.message.setMessage,
  }))

  const [lazyMyQueueList, fetchMyQueueListHandler] = useLazyApiData(fetchMyQueueList)
  const [selectedFilterData, setSelectedFilterData] = useState({})
  const [filterVisible, setFilterVisible] = useState(false)
  const [searchByEntityIdInfo, setSearchByEntityIdInfo] = useState<any>({})

  useEffect(() => {
    const initialSelectedFilterData =
      JSON.parse(localStorage.getItem(name + '-filterData')) ?? SCREEN_MAAPPER_CHECKER_MY_TASK[name]?.filterInitialValue
    setSelectedFilterData(initialSelectedFilterData)
  }, [])

  const parseFilterData = useCallback((filterData) => {
    const parsedFilterData: any = Object.keys(filterData).reduce(
      (acc, item) => ({
        ...acc,
        ...(item !== 'startDateOrder' && { [item]: filterData?.[item]?.map((data) => data?.key) }),
        ...(item === 'startDateOrder' && { [item]: filterData?.[item]?.[0]?.key }),
      }),
      {},
    )
    return parsedFilterData
  }, [])

  const fetchMyEntityQueueAsync = useCallback(
    (formattedFilteredData, extraReqParams = {}) => {
      lazyMyQueueList({
        pageNumber: pagination?.number - 1,
        pageSize: 10,
        startDate: dateFormatter(selectedDateInfo?.fromDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
        endDate: dateFormatter(selectedDateInfo?.toDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
        ...parseFilterData(formattedFilteredData),
        ...extraReqParams,
      })
    },
    [lazyMyQueueList, pagination?.number, parseFilterData, selectedDateInfo?.fromDate, selectedDateInfo?.toDate],
  )

  console.log('routes', name)
  console.log('navigation', navigation)

  useEffect(() => {
    fetchMyEntityQueueAsync(selectedFilterData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (fetchMyQueueListHandler?.state === 'fulfilled' && searchByEntityIdInfo?.applicationId) {
      setSearchByEntityIdInfo({ ...searchByEntityIdInfo, showCross: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchMyQueueListHandler?.state])
  const { width } = useWindowDimensions()

  const onApplyFiter = useCallback(
    (selectedFilter: any) => {
      localStorage.setItem(name + '-filterData', JSON.stringify(selectedFilter))
      setSelectedFilterData(selectedFilter)
      fetchMyEntityQueueAsync(selectedFilter, { applicationId: searchByEntityIdInfo?.applicationId })
    },
    [fetchMyEntityQueueAsync, searchByEntityIdInfo?.applicationId],
  )

  console.log('fetchMyQueueListHandler?.data', fetchMyQueueListHandler?.data)
  const onRowItemPress = useCallback(
    (item) => {
      if (
        !item?.taskInstanceId &&
        SCREEN_MAAPPER_CHECKER_MY_TASK[name]?.validStatesForAction?.includes(item?.applicationStatus)
      ) {
        setMessage('Application under progress, please try after some time or refresh.', MessageTypes.ERROR)
      } else {
        navigation.navigate('myOnboardedEntityDetails', { item: item, name: name })
      }
    },
    [name, navigation],
  )

  return (
    <Box {...styles.container}>
      <CheckerHeader
        title={'Work Items'}
        fetchDataOnChange={() =>
          fetchMyEntityQueueAsync(selectedFilterData, { applicationId: searchByEntityIdInfo?.applicationId })
        }
        filterVisible={filterVisible}
        setFilterVisible={setFilterVisible}
        onSearchByEntityIdClick={(applicationId) => {
          setSearchByEntityIdInfo({ ...searchByEntityIdInfo, applicationId, showCross: false })
          console.log('selectedFilterData =', selectedFilterData)
          fetchMyEntityQueueAsync(selectedFilterData, { applicationId })
        }}
        showSearchByCrossButton={searchByEntityIdInfo?.showCross}
        showSearchByLoader={fetchMyQueueListHandler.state === 'pending'}
        filterApplied={undefined}
        exportFile={undefined}
        showRefresh={true}
        onRefresh={() => lazyMyQueueList()}
        showDownloadButton={['checker1MyQueue', 'checker2MyQueue'].includes(name)}
        selectedFilterData={{
          jobType: SCREEN_MAAPPER_CHECKER_MY_TASK[name]?.jobType,
          checkerFilter: {
            ...parseFilterData(selectedFilterData),
            ...(searchByEntityIdInfo?.applicationId && { applicationId: searchByEntityIdInfo?.applicationId }),
            startDate: dateFormatter(selectedDateInfo?.fromDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
            endDate: dateFormatter(selectedDateInfo?.toDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
            requestType: ['NEW_PROFILE'],
          },
        }}
      />
      <Container
        isLoading={fetchMyQueueListHandler?.state === 'pending'}
        errorMessage={fetchMyQueueListHandler?.data?.message}
        emptyMessage={
          fetchMyQueueListHandler?.state === 'fulfilled' &&
          fetchMyQueueListHandler?.data?.length === 0 &&
          'No Data Found'
        }
        onRetry={() => lazyMyQueueList()}>
        <NewTable
          data={fetchMyQueueListHandler?.data ?? []}
          rowHeight={48}
          headerHeight={64}
          height={544}
          customWidthFunc={getCustomColumnWidth}
          tableWidth={width > 1200 ? width - 290 : width}
          headerRowKeys={checker1HeaderTitles}
          onRowClick={onRowItemPress}
          onRetry={() => {}}
        />
      </Container>
      <FiltersModal
        show={filterVisible}
        onDismiss={() => setFilterVisible(false)}
        initialValue={selectedFilterData}
        data={SCREEN_MAAPPER_CHECKER_MY_TASK[name]?.filterData}
        onApplyFiter={onApplyFiter}
        onReset={() => onApplyFiter(SCREEN_MAAPPER_CHECKER_MY_TASK[name]?.filterInitialValue)}
      />
    </Box>
  )
}

export default MyOnboardedEntityQueue

export const getCustomColumnWidth = (columnKey: string) => {
  const columnsKeyWidth: any = {
    applicationId: 100,
    businessLegalName: 100,
    landlineNumber: 100,
    requestType: 100,
    programCategory: 100,
    createdAt: 100,
    applicationStatus: 100,
  }
  return columnsKeyWidth[columnKey] ?? 150
}

const styles = {
  container: {
    h: '100%',
    borderRadius: 8,
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
  } as BoxProps,
  innerContainer: {
    flexDirection: 'row',
    flex: 1,
  } as BoxProps,
}

export const checker1HeaderTitles = {
  applicationId: 'Application ID',
  businessLegalName: 'Legal Name',
  personalMobileNumber: 'Mobile Number',
  businessChannel: 'Business Channel',
  requestType: 'Request Type',
  createdAt: 'Creation Date & Time',
  applicationStatus: 'Status',
}

const MY_QUEUE_FILTER_DATA = [
  {
    labelKey: 'applicationState',
    labelDescription: 'By Status',
    checkBoxItems: [
      {
        key: 'OPS_CHECKER_ONE',
        description: 'OPS_CHECKER_ONE',
      },
      {
        key: 'OPS_CHECKER_TWO',
        description: 'OPS_CHECKER_TWO',
      },
      {
        key: 'OPS_REJECT',
        description: 'OPS_REJECT',
      },
      {
        key: 'OPS_HOLD',
        description: 'OPS_HOLD',
      },
      {
        key: 'OPS_MAKER_REWORK',
        description: 'OPS_MAKER_REWORK',
      },
      {
        key: 'OPS_CHECKER_REWORK',
        description: 'OPS_CHECKER_REWORK',
      },
      {
        key: 'RISK_APPROVED',
        description: 'RISK_APPROVED',
      },
      {
        key: 'RISK_MAKER',
        description: 'RISK_MAKER',
      },
      {
        key: 'RISK_CHECKER_ONE',
        description: 'RISK_CHECKER_ONE',
      },
      {
        key: 'APPROVED',
        description: 'APPROVED',
      },
      {
        key: 'FULFILLMENT',
        description: 'FULFILLMENT',
      },
      {
        key: 'COMPLETED',
        description: 'COMPLETED',
      },
      {
        key: 'AML_ON_HOLD',
        description: 'AML_ON_HOLD',
      },
      {
        key: 'AML_FAILED',
        description: 'AML_FAILED',
      },
      {
        key: 'AML_REJECT',
        description: 'AML_REJECT',
      },
      {
        key: 'DEDUPE_REJECT',
        description: 'DEDUPE_REJECT',
      },
      {
        key: 'RISK_REJECT',
        description: 'RISK_REJECT',
      },
      {
        key: 'RISK_HOLD',
        description: 'RISK_HOLD',
      },
    ],
  },
  {
    labelKey: 'requestType',
    labelDescription: 'By Request Type',
    checkBoxItems: [
      {
        key: 'NEW_PROFILE',
        description: 'New Merchant',
      },
      {
        key: 'UPDATE_PROFILE',
        description: 'Merchant Update',
      },
      {
        key: 'RISK_UPDATE_PROFILE',
        description: 'RISK_UPDATE_PROFILE',
      },
      {
        key: 'RISK_COMMENT_ONLY',
        description: 'RISK_COMMENT_ONLY',
      },
    ],
  },
  {
    labelKey: 'startDateOrder',
    labelDescription: 'Sort By',
    singleSelection: true,
    defaultSelected: 'Desc',
    checkBoxItems: [
      {
        key: 'Asc',
        description: 'Ascending',
      },
      {
        key: 'Desc',
        description: 'Descending',
      },
    ],
  },
]

const CHECKER_FILTER_DATA = [
  {
    labelKey: 'applicationState',
    labelDescription: 'By Status',
    checkBoxItems: [
      {
        key: 'OPS_CHECKER_ONE',
        description: 'OPS_CHECKER_ONE',
      },
      {
        key: 'OPS_CHECKER_TWO',
        description: 'OPS_CHECKER_TWO',
      },
      {
        key: 'OPS_REJECT',
        description: 'OPS_REJECT',
      },
      {
        key: 'OPS_HOLD',
        description: 'OPS_HOLD',
      },
      {
        key: 'OPS_MAKER_REWORK',
        description: 'OPS_MAKER_REWORK',
      },
      {
        key: 'OPS_CHECKER_REWORK',
        description: 'OPS_CHECKER_REWORK',
      },
      {
        key: 'RISK_APPROVED',
        description: 'RISK_APPROVED',
      },
      {
        key: 'RISK_MAKER',
        description: 'RISK_MAKER',
      },
      {
        key: 'RISK_CHECKER_ONE',
        description: 'RISK_CHECKER_ONE',
      },
      {
        key: 'APPROVED',
        description: 'APPROVED',
      },
      {
        key: 'FULFILLMENT',
        description: 'FULFILLMENT',
      },
      {
        key: 'COMPLETED',
        description: 'COMPLETED',
      },
      {
        key: 'AML_ON_HOLD',
        description: 'AML_ON_HOLD',
      },
      {
        key: 'AML_FAILED',
        description: 'AML_FAILED',
      },
      {
        key: 'AML_REJECT',
        description: 'AML_REJECT',
      },
      {
        key: 'DEDUPE_REJECT',
        description: 'DEDUPE_REJECT',
      },
      {
        key: 'RISK_REJECT',
        description: 'RISK_REJECT',
      },
      {
        key: 'RISK_HOLD',
        description: 'RISK_HOLD',
      },
    ],
  },
  {
    labelKey: 'requestType',
    labelDescription: 'By Request Type',
    checkBoxItems: [
      {
        key: 'NEW_PROFILE',
        description: 'New Merchant',
      },
      {
        key: 'UPDATE_PROFILE',
        description: 'Merchant Update',
      },
      {
        key: 'RISK_UPDATE_PROFILE',
        description: 'RISK_UPDATE_PROFILE',
      },
      {
        key: 'BULK_TERMINAL_ADD',
        description: 'Bulk Terminal Add',
      },
      {
        key: 'RISK_COMMENT_ONLY',
        description: 'RISK_COMMENT_ONLY',
      },
    ],
  },
  {
    labelKey: 'startDateOrder',
    labelDescription: 'Sort By',
    singleSelection: true,
    defaultSelected: 'Desc',
    checkBoxItems: [
      {
        key: 'Asc',
        description: 'Ascending',
      },
      {
        key: 'Desc',
        description: 'Descending',
      },
    ],
  },
]
const getIntialValue = (data) =>
  data.reduce((acc, category) => {
    acc[category.labelKey] = category.checkBoxItems
      .map((item) => ({
        ...item,
        isChecked:
          (category?.singleSelection && item?.key === category?.defaultSelected) || !category?.singleSelection
            ? true
            : false,
      }))
      .filter((item) => item?.isChecked)
    return acc
  }, {})

export const SCREEN_MAAPPER_CHECKER_MY_TASK = {
  makerMyEntityQueue: {
    validStatesForAction: ['OPS_MAKER_REWORK'],
    totalFilledStep: 8,
    onBoardingSteps: [
      'Business Contact',
      'Authorised Signatory',
      'Business Details',
      'Other Business Details',
      'Bank Details',
      'Document Upload',
      'Fee/Package Details',
      'Kyc approval data',
    ],
    submitActions: [
      {
        key: 'SUBMIT',
        description: 'SUBMIT',
      },
    ],
    filterData: MY_QUEUE_FILTER_DATA,
    filterInitialValue: getIntialValue(MY_QUEUE_FILTER_DATA),
  },
  checker1MyQueue: {
    validStatesForAction: ['OPS_CHECKER_ONE', 'OPS_HOLD', 'OPS_CHECKER_REWORK'],
    totalFilledStep: 9,
    onBoardingSteps: [
      'Select Parent',
      'Business Contact',
      'Authorised Signatory',
      'Business Details',
      'Other Business Details',
      'Bank Details',
      'Document Upload',
      'Fee/Package Details',
      'Kyc approval data',
    ],
    submitActions: [
      {
        key: 'APPROVE',
        description: 'APPROVE',
      },
      {
        key: 'RISK_REFER',
        description: 'RISK_REFER',
      },
      {
        key: 'REWORK',
        description: 'REWORK',
      },
      {
        key: 'REJECT',
        description: 'REJECT',
      },

      {
        key: 'HOLD',
        description: 'HOLD',
      },
      {
        key: 'RELEASE_HOLD',
        description: 'RELEASE_HOLD',
      },
    ],
    commentTitle: 'Checker1 comments',
    filterData: CHECKER_FILTER_DATA,
    filterInitialValue: getIntialValue(CHECKER_FILTER_DATA),
    jobType: 'CHECKER_ONE_APPROVE_EXPORT',
  },
  checker2MyQueue: {
    validStatesForAction: ['OPS_CHECKER_TWO', 'RISK_APPROVED'],
    totalFilledStep: 10,
    onBoardingSteps: [
      'Select Parent',
      'Business Contact',
      'Authorised Signatory',
      'Business Details',
      'Other Business Details',
      'Bank Details',
      'Document Upload',
      'Fee/Package Details',
      'Kyc approval data',
      'Risk Settings',
    ],
    submitActions: [
      {
        key: 'APPROVE',
        description: 'APPROVE',
      },
      {
        key: 'REWORK',
        description: 'REWORK',
      },
      {
        key: 'REJECT',
        description: 'REJECT',
      },
    ],
    commentTitle: 'Checker2 comments',
    filterData: CHECKER_FILTER_DATA,
    filterInitialValue: getIntialValue(CHECKER_FILTER_DATA),
    jobType: 'CHECKER_TWO_APPROVE_EXPORT',
  },
  riskCheckerMyQueue: {
    validStatesForAction: ['RISK_CHECKER_ONE'],
    totalFilledStep: 11,
    onBoardingSteps: [
      'Select Parent',
      'Business Contact',
      'Authorised Signatory',
      'Business Details',
      'Other Business Details',
      'Bank Details',
      'Document Upload',
      'Fee/Package Details',
      'Kyc approval data',
      'Risk Settings',
      'Interaction History',
    ],
    submitActions: [
      {
        key: 'APPROVE',
        description: 'APPROVE',
      },
      {
        key: 'REWORK',
        description: 'REWORK',
      },
      {
        key: 'REJECT',
        description: 'REJECT',
      },
    ],
    commentTitle: 'Risk Checker external comments',
    internalCommentTitle: 'Risk Checker internal comments',
    filterData: MY_QUEUE_FILTER_DATA,
    filterInitialValue: getIntialValue(MY_QUEUE_FILTER_DATA),
  },
  riskMakerMyQueue: {
    validStatesForAction: ['RISK_MAKER', 'RISK_HOLD'],
    totalFilledStep: 11,
    onBoardingSteps: [
      'Select Parent',
      'Business Contact',
      'Authorised Signatory',
      'Business Details',
      'Other Business Details',
      'Bank Details',
      'Document Upload',
      'Fee/Package Details',
      'Kyc approval data',
      'Risk Settings',
      'Interaction History',
    ],
    submitActions: [
      {
        key: 'APPROVE',
        description: 'APPROVE',
      },
      {
        key: 'HOLD',
        description: 'HOLD',
      },
      {
        key: 'REJECT',
        description: 'REJECT',
      },
      {
        key: 'RELEASE_HOLD',
        description: 'RELEASE_HOLD',
      },
    ],
    commentTitle: 'Risk Maker external comments',
    internalCommentTitle: 'Risk Maker internal comments',
    filterData: MY_QUEUE_FILTER_DATA,
    filterInitialValue: getIntialValue(MY_QUEUE_FILTER_DATA),
  },
  MAKER_SEARCH_ENTITY: {
    validStatesForAction: ['UPDATE_PROFILE'],
    totalFilledStep: 10,
    onBoardingSteps: [
      'Select Parent',
      'Business Contact',
      'Authorised Signatory',
      'Business Details',
      'Other Business Details',
      'Bank Details',
      'Document Upload',
      'Fee/Package Details',
      'Risk Settings',
      'Interaction History',
    ],
    submitActions: [
      {
        key: 'SUBMIT',
        description: 'SUBMIT',
      },
    ],
    filterData: [],
    filterInitialValue: {},
  },
  RISK_MAKER_SEARCH_ENTITY: {
    validStatesForAction: ['UPDATE_PROFILE'],
    totalFilledStep: 10,
    onBoardingSteps: [
      'Select Parent',
      'Business Contact',
      'Authorised Signatory',
      'Business Details',
      'Other Business Details',
      'Bank Details',
      'Document Upload',
      'Fee/Package Details',
      'Risk Settings',
      'Interaction History',
    ],
    submitActions: [
      {
        key: 'APPROVE',
        description: 'APPROVE',
      },
      {
        key: 'SUBMIT_COMMENTS',
        description: 'SUBMIT ',
      },
      {
        key: 'VERIFY_COMMENTS',
        description: 'PROCESS',
      },
    ],
    filterData: [],
    filterInitialValue: {},
  },
  DEFAULT_SEARCH_ENTITY: {
    validStatesForAction: ['UPDATE_PROFILE'],
    totalFilledStep: 10,
    onBoardingSteps: [
      'Select Parent',
      'Business Contact',
      'Authorised Signatory',
      'Business Details',
      'Other Business Details',
      'Bank Details',
      'Document Upload',
      'Fee/Package Details',
      'Risk Settings',
    ],
    submitActions: [
      {
        key: 'APPROVE',
        description: 'APPROVE',
      },
      {
        key: 'HOLD',
        description: 'HOLD',
      },
      {
        key: 'REJECT',
        description: 'REJECT',
      },
    ],
    filterData: [],
    filterInitialValue: {},
  },
}
